(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-wildflower-bundle-builder"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.WildflowerBundleBuilder) {
      window.WildflowerBundleBuilder.boot();
      return;
    }

    class WildflowerBundleBuilder {
      static instances = new WeakMap();

      static boot(scope = document) {
        scope.querySelectorAll('[data-wf-bundle]').forEach((root) => {
          if (WildflowerBundleBuilder.instances.has(root)) return;

          const instance = new WildflowerBundleBuilder(root);
          WildflowerBundleBuilder.instances.set(root, instance);
        });
      }

      static destroy(scope) {
        scope.querySelectorAll('[data-wf-bundle]').forEach((root) => {
          const instance = WildflowerBundleBuilder.instances.get(root);

          instance?.destroy();
          WildflowerBundleBuilder.instances.delete(root);
        });
      }

      constructor(root) {
        this.root = root;
        this.controller = new AbortController();
        this.currency = root.dataset.currency || 'AUD';
        this.locale = root.dataset.locale || 'en-AU';
        this.money = new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        });

        this.cartTotal = 0;
        this.defaultGoalQuantity = Number(root.dataset.defaultTarget || 2);
        this.requireSizeSelection = root.dataset.requireSizeSelection === 'true';
        this.goalQuantity = this.requireSizeSelection
          ? 0
          : this.defaultGoalQuantity;

        this.discountTwo = Number(root.dataset.discountTwo || 10);
        this.discountThree = Number(root.dataset.discountThree || 15);
        this.discountFour = Number(root.dataset.discountFour || 20);
        this.isOpen = root.dataset.defaultOpen === 'true';
        this.autoSelectCurrent = root.dataset.autoSelectCurrent === 'true';
        this.currentProductId = root.dataset.currentProductId || '';
        this.hasAutoSelectedCurrent = false;
        this.toggle = root.querySelector('[data-wf-toggle]');
        this.panel = root.querySelector('[data-wf-panel]');

        this.removeDuplicateProducts();
        this.revealComponents();
        this.bind();
        this.setOpen(this.isOpen, false);
        this.update();
        this.fetchCart();
      }

      revealComponents() {
        this.root.querySelectorAll(
          '[data-wf-summary], [data-wf-progress], [data-wf-atc-wrapper], [data-wf-gift], [data-wf-benefit]'
        ).forEach((component) => {
          component.hidden = false;
        });
      }

      removeDuplicateProducts() {
        const productIds = new Set();

        this.root.querySelectorAll('[data-wf-product]').forEach((card) => {
          const productId = card.dataset.productId;

          if (!productId || !productIds.has(productId)) {
            if (productId) productIds.add(productId);
            return;
          }

          card.remove();
        });
      }

      bind() {
        const signal = this.controller.signal;

        this.root.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;

          if (event.target.closest('[data-wf-toggle]')) {
            this.setOpen(!this.isOpen, true);
            return;
          }

          const tier = event.target.closest('[data-wf-tier]');

          if (tier) {
            this.goalQuantity = Number(tier.dataset.target || 1);
            this.update();

            this.root.querySelector('[data-wf-selection]')?.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth',
              block: 'nearest'
            });

            return;
          }

          const card = event.target.closest('[data-wf-product]');

          if (card && event.target.closest('[data-wf-add]')) {
            this.changeQuantity(card, 1);
            return;
          }

          if (card && event.target.closest('[data-wf-minus]')) {
            this.changeQuantity(card, -1);
            return;
          }

          if (card && event.target.closest('[data-wf-plus]')) {
            this.changeQuantity(card, 1);
            return;
          }


          if (
            card &&
            Number(card.dataset.quantity || 0) === 0 &&
            !event.target.closest('button, select, input, a, label')
          ) {
            this.changeQuantity(card, 1);
            return;
          }

          const atc = event.target.closest('[data-wf-atc]');

          if (atc) this.addToCart(atc);
        }, { signal });

        this.root.addEventListener('change', (event) => {
          if (!(event.target instanceof Element)) return;

          const select = event.target.closest('[data-wf-variant]');

          if (select) {
            const card = select.closest('[data-wf-product]');
            const option = select.selectedOptions[0];

            if (!card || !option) return;

            card.dataset.variantId = option.value;
            card.dataset.price = option.dataset.price;
            card.dataset.available = option.dataset.available;

            const imageElement = card.querySelector('.wf-bundle__product-image');

            if (imageElement && option.dataset.image) {
              imageElement.src = option.dataset.image;
              imageElement.removeAttribute('srcset');
            }

            const priceElement = card.querySelector('[data-wf-card-price]');

            if (priceElement) {
              priceElement.textContent = this.format(
                Number(option.dataset.price || 0)
              );
            }

            if (option.dataset.available !== 'true') {
              this.setQuantity(card, 0);
            }

            this.update();
            return;
          }

          if (event.target.matches('[data-wf-gift-checkbox]')) {
            this.update();
          }
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          if (
            event.target instanceof Element &&
            event.target.closest('[data-wf-bundle]') === this.root
          ) {
            this.setOpen(true, false);
          }
        }, { signal });

        document.addEventListener('cart:update', (event) => {
          if (event.target !== this.root) {
            this.fetchCart();
          }
        }, { signal });
      }

      destroy() {
        this.controller.abort();
      }

      setOpen(open, focus) {
        this.isOpen = open;
        this.toggle?.setAttribute('aria-expanded', String(open));

        if (this.panel) {
          this.panel.hidden = !open;
        }

        if (open) {
          this.autoSelectCurrentProduct();
        }

        if (focus && open) {
          this.panel?.focus({ preventScroll: true });
        }
      }

      autoSelectCurrentProduct() {
        if (
          !this.autoSelectCurrent ||
          this.hasAutoSelectedCurrent ||
          !this.currentProductId
        ) {
          return;
        }

        this.hasAutoSelectedCurrent = true;

        const currentCard = Array.from(
          this.root.querySelectorAll('[data-wf-product]')
        ).find((card) => {
          return card.dataset.productId === this.currentProductId;
        });

        if (!currentCard || currentCard.dataset.available !== 'true') {
          return;
        }

        if (Number(currentCard.dataset.quantity || 0) === 0) {
          this.setQuantity(currentCard, 1);
        }

        this.update();
      }

      setQuantity(card, value) {
        const quantity = Math.max(0, Math.min(Number(value), 99));

        card.dataset.quantity = String(quantity);

        const output = card.querySelector('[data-wf-quantity]');

        if (output) {
          output.textContent = String(quantity);
        }
      }

      changeQuantity(card, change) {
        if (card.dataset.available !== 'true') return;

        if (change > 0 && this.goalQuantity <= 0) {
          this.root.querySelector('[data-wf-tier]')?.focus({
            preventScroll: true
          });

          return;
        }

        const state = this.state();

        if (
          change > 0 &&
          this.goalQuantity < 4 &&
          state.quantity >= this.goalQuantity
        ) {
          return;
        }

        this.setQuantity(
          card,
          Number(card.dataset.quantity || 0) + change
        );

        this.update();
      }

      isGoalComplete(quantity) {
        if (this.goalQuantity <= 0) return false;

        return this.goalQuantity >= 4
          ? quantity >= this.goalQuantity
          : quantity === this.goalQuantity;
      }

      discountFor(quantity) {
        if (quantity >= 4) return this.discountFour;
        if (quantity === 3) return this.discountThree;
        if (quantity === 2) return this.discountTwo;

        return 0;
      }

      lines() {
        return Array.from(
          this.root.querySelectorAll('[data-wf-product]')
        )
          .map((card) => ({
            card,
            id: Number(card.dataset.variantId),
            quantity: Number(card.dataset.quantity || 0),
            price: Number(card.dataset.price || 0),
            available: card.dataset.available === 'true'
          }))
          .filter((line) => line.quantity > 0);
      }

      gift() {
        const input = this.root.querySelector('[data-wf-gift-checkbox]');

        if (!input || !input.checked || input.disabled) {
          return null;
        }

        return {
          id: Number(input.dataset.variantId),
          quantity: 1,
          price: Number(input.dataset.price || 0),
          available: input.dataset.available === 'true'
        };
      }

      state() {
        const lines = this.lines();

        const quantity = lines.reduce(
          (total, line) => total + line.quantity,
          0
        );

        const original = lines.reduce(
          (total, line) => total + line.price * line.quantity,
          0
        );

        const discount = this.discountFor(quantity);
        const saving = Math.round(original * discount / 100);
        const gift = this.gift();
        const giftTotal = gift ? gift.price : 0;
        const goalComplete = this.isGoalComplete(quantity);

        return {
          lines,
          quantity,
          original,
          discount,
          saving,
          discounted: original - saving,
          gift,
          giftTotal,
          goalQuantity: this.goalQuantity,
          goalComplete,
          projectedTotal:
            this.cartTotal +
            original -
            saving +
            giftTotal,
          valid:
            goalComplete &&
            quantity > 0 &&
            lines.every((line) => line.available)
        };
      }

      format(cents) {
        return this.money.format(Number(cents || 0) / 100);
      }

      update() {
        const state = this.state();

        const canIncrease =
          this.goalQuantity > 0 &&
          (
            this.goalQuantity >= 4 ||
            state.quantity < this.goalQuantity
          );

        this.root.querySelectorAll('[data-wf-tier]').forEach((button) => {
          const target = Number(button.dataset.target);
          const active = target === this.goalQuantity;

          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        const selection = this.root.querySelector('[data-wf-selection]');

        if (selection) {
          selection.classList.toggle(
            'is-awaiting-size',
            this.goalQuantity <= 0
          );

          selection.classList.toggle(
            'is-complete',
            state.goalComplete
          );

          selection.setAttribute(
            'aria-disabled',
            String(this.goalQuantity <= 0)
          );
        }

        this.root.querySelectorAll('[data-wf-product]').forEach((card) => {
          const quantity = Number(card.dataset.quantity || 0);
          const available = card.dataset.available === 'true';
          const addButton = card.querySelector('[data-wf-add]');
          const controls = card.querySelector(
            '[data-wf-quantity-controls]'
          );

          card.classList.toggle('is-selected', quantity > 0);

          if (addButton) {
            addButton.hidden = quantity > 0;
            addButton.toggleAttribute(
              'disabled',
              !available || !canIncrease
            );
          }

          if (controls) {
            controls.hidden = quantity === 0;
          }

          card
            .querySelector('[data-wf-minus]')
            ?.toggleAttribute('disabled', quantity === 0);

          card
            .querySelector('[data-wf-plus]')
            ?.toggleAttribute(
              'disabled',
              !available ||
                !canIncrease ||
                quantity >= 99
            );

          card.querySelectorAll('[data-wf-variant]').forEach((select) => {
            select.toggleAttribute(
              'disabled',
              this.goalQuantity <= 0 ||
                card.classList.contains('is-unavailable')
            );
          });
        });

        const count = this.root.querySelector('[data-wf-count]');

        if (count) {
          if (this.goalQuantity <= 0) {
            const label =
              state.quantity === 1
                ? this.root.dataset.singularLabel
                : this.root.dataset.pluralLabel;

            count.textContent = `${state.quantity} ${label}`;
          } else {
            const target =
              `${this.goalQuantity}` +
              `${this.goalQuantity >= 4 ? '+' : ''}`;

            count.textContent =
              `${state.quantity} / ${target} ` +
              `${this.root.dataset.pluralLabel}`;
          }
        }

        const selectionPrompt = this.root.querySelector(
          '[data-wf-selection-prompt]'
        );

        if (selectionPrompt) {
          if (this.goalQuantity <= 0) {
            selectionPrompt.textContent =
              this.root.dataset.chooseSizeText;
          } else if (state.quantity < this.goalQuantity) {
            const remaining =
              this.goalQuantity - state.quantity;

            const label =
              remaining === 1
                ? this.root.dataset.singularLabel
                : this.root.dataset.pluralLabel;

            selectionPrompt.textContent =
              this.root.dataset.remainingText
                .replace('[quantity]', String(remaining))
                .replace('[label]', label);
          } else if (
            this.goalQuantity < 4 &&
            state.quantity > this.goalQuantity
          ) {
            const extra =
              state.quantity - this.goalQuantity;

            const label =
              extra === 1
                ? this.root.dataset.singularLabel
                : this.root.dataset.pluralLabel;

            selectionPrompt.textContent =
              this.root.dataset.overSelectedText
                .replace('[quantity]', String(extra))
                .replace('[label]', label);
          } else {
            selectionPrompt.textContent =
              this.root.dataset.completeText;
          }
        }

        const status = this.root.querySelector('[data-wf-status]');

        if (status) {
          if (state.goalComplete && state.discount > 0) {
            status.textContent =
              this.root.dataset.discountUnlockedText.replace(
                '[discount]',
                String(state.discount)
              );
          } else {
            status.textContent = '';
          }
        }

        this.updateSummary(state);
        this.updateProgress(state);
        this.updateAtc(state);
        this.emit(state);
      }

      updateSummary(state) {
        this.root
          .querySelectorAll('[data-wf-summary]')
          .forEach((summary) => {
            const label =
              state.quantity === 1
                ? summary.dataset.singularLabel ||
                  this.root.dataset.singularLabel
                : summary.dataset.pluralLabel ||
                  this.root.dataset.pluralLabel;

            const primary = summary.querySelector(
              '[data-wf-summary-primary]'
            );

            const secondary = summary.querySelector(
              '[data-wf-summary-secondary]'
            );

            const badge = summary.querySelector(
              '[data-wf-saving]'
            );

            if (primary) {
              primary.textContent =
                summary.dataset.selectedText
                  .replace(
                    '[quantity]',
                    String(state.quantity)
                  )
                  .replace('[label]', label);
            }

            if (secondary) {
              secondary.textContent =
                summary.dataset.totalText
                  .replace(
                    '[original]',
                    this.format(state.original)
                  )
                  .replace(
                    '[total]',
                    this.format(state.discounted)
                  );
            }

            if (badge) {
              badge.textContent =
                summary.dataset.savingText.replace(
                  '[amount]',
                  this.format(state.saving)
                );

              badge.hidden = state.saving <= 0;
            }
          });
      }

      updateProgress(state) {
        this.root
          .querySelectorAll('[data-wf-progress]')
          .forEach((progress) => {
            const thresholdValue =
              this.root.dataset.country === 'NZ'
                ? Number(
                    progress.dataset.thresholdNz ||
                    progress.dataset.thresholdAu
                  )
                : Number(progress.dataset.thresholdAu);

            const threshold =
              Math.round(thresholdValue * 100);

            const remaining =
              Math.max(
                0,
                threshold - state.projectedTotal
              );

            const ratio =
              threshold > 0
                ? Math.min(
                    1,
                    state.projectedTotal / threshold
                  )
                : 1;

            const message = progress.querySelector(
              '[data-wf-progress-message]'
            );

            const fill = progress.querySelector(
              '[data-wf-progress-fill]'
            );

            if (message) {
              message.textContent =
                remaining > 0
                  ? progress.dataset.remainingText.replace(
                      '[amount]',
                      this.format(remaining)
                    )
                  : progress.dataset.unlockedText;
            }

            if (fill) {
              fill.style.transform = `scaleX(${ratio})`;
            }

            progress.setAttribute(
              'aria-valuenow',
              String(Math.round(ratio * 100))
            );
          });
      }

      updateAtc(state) {
        this.root
          .querySelectorAll('[data-wf-atc]')
          .forEach((button) => {
            button.disabled = !state.valid;

            const label = button.querySelector(
              '[data-wf-atc-label]'
            );

            if (!label) return;

            if (state.valid) {
              label.textContent =
                button.dataset.readyText
                  .replace(
                    '[quantity]',
                    String(state.quantity)
                  )
                  .replace(
                    '[total]',
                    this.format(
                      state.discounted +
                      state.giftTotal
                    )
                  );
            } else if (this.goalQuantity <= 0) {
              label.textContent =
                this.root.dataset.chooseSizeText;
            } else if (
              state.quantity > this.goalQuantity &&
              this.goalQuantity < 4
            ) {
              const extra =
                state.quantity - this.goalQuantity;

              const itemLabel =
                extra === 1
                  ? this.root.dataset.singularLabel
                  : this.root.dataset.pluralLabel;

              label.textContent =
                this.root.dataset.overSelectedText
                  .replace(
                    '[quantity]',
                    String(extra)
                  )
                  .replace('[label]', itemLabel);
            } else {
              const remaining =
                Math.max(
                  1,
                  this.goalQuantity - state.quantity
                );

              label.textContent =
                button.dataset.incompleteText.replace(
                  '[quantity]',
                  String(remaining)
                );
            }
          });
      }

      async fetchCart() {
        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}cart.js`,
            {
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!response.ok) return;

          const cart = await response.json();

          this.cartTotal = Number(
            cart.total_price || 0
          );

          this.update();
        } catch {
          this.cartTotal = 0;
          this.update();
        }
      }

      async addToCart(button) {
        const state = this.state();

        if (
          !state.valid ||
          button.classList.contains('is-loading')
        ) {
          return;
        }

        const groupId =
          `wf-${Date.now()}-` +
          `${Math.random().toString(36).slice(2, 9)}`;

        const properties = {
          _bundle_source: 'wildflower_pdp_bundle',
          _bundle_tier:
            state.quantity >= 4
              ? '4+'
              : String(state.quantity),
          _bundle_discount: `${state.discount}%`,
          _bundle_group_id: groupId
        };

        const items = state.lines.map((line) => ({
          id: line.id,
          quantity: line.quantity,
          properties
        }));

        if (state.gift?.available) {
          items.push({
            id: state.gift.id,
            quantity: 1,
            properties: {
              _bundle_source:
                'wildflower_pdp_bundle_gift',
              _bundle_group_id: groupId
            }
          });
        }

        const sectionIds = Array.from(
          document.querySelectorAll(
            'cart-items-component[data-section-id]'
          )
        )
          .map((component) => component.dataset.sectionId)
          .filter(Boolean);

        const payload = {
          items,
          sections: [...new Set(sectionIds)].join(','),
          sections_url: window.location.pathname
        };

        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        this.feedback(button, '');

        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            }
          );

          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
              result.message ||
              button.dataset.errorText
            );
          }

          this.root.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: this.root.id,
                data: {
                  source: 'wildflower-bundle',
                  itemCount: items.reduce(
                    (total, item) =>
                      total + item.quantity,
                    0
                  ),
                  sections: result.sections || {}
                }
              }
            })
          );

          this.feedback(
            button,
            button.dataset.successText
          );

          this.resetSelection();
          await this.fetchCart();
        } catch (error) {
          this.feedback(
            button,
            error.message ||
            button.dataset.errorText,
            true
          );

          await this.fetchCart();
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          this.update();
        }
      }

      feedback(button, message, error = false) {
        const wrapper = button.closest(
          '[data-wf-atc-wrapper]'
        );

        const feedback = wrapper?.querySelector(
          '[data-wf-feedback]'
        );

        if (!feedback) return;

        feedback.textContent = message;
        feedback.classList.toggle(
          'is-error',
          error
        );
      }

      resetSelection() {
        this.root
          .querySelectorAll('[data-wf-product]')
          .forEach((card) => {
            this.setQuantity(card, 0);
          });

        const gift = this.root.querySelector(
          '[data-wf-gift-checkbox]'
        );

        if (gift) {
          gift.checked = false;
        }

        this.goalQuantity =
          this.requireSizeSelection
            ? 0
            : this.defaultGoalQuantity;

        this.hasAutoSelectedCurrent = false;
        this.autoSelectCurrentProduct();
      }

      emit(state) {
        this.root.dispatchEvent(
          new CustomEvent(
            'wildflower:bundle-change',
            {
              bubbles: true,
              detail: {
                id: this.root.id,
                state
              }
            }
          )
        );
      }
    }

    window.WildflowerBundleBuilder =
      WildflowerBundleBuilder;

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => WildflowerBundleBuilder.boot(),
        { once: true }
      );
    } else {
      WildflowerBundleBuilder.boot();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        WildflowerBundleBuilder.boot(event.target);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        WildflowerBundleBuilder.destroy(event.target);
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
